/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /*
     Creates a page header
     */
    app.directive('enerveeHeader', function () {

        return {
            // must be an element (can not be used as an attribute or ...)
            restrict: 'E',
            replace: true,
            scope: {},
            controller: [
                '$log',
                '$scope',
                '$state',
                'CookiesService',
                'HeaderService',
                'CategoriesService',
                'FiltersSortByService',
                'IndexService',
                'AccountAuthService',
                'SignupService',
                'UtilService',
                'CmsContentService',
                'NavLinksService',
                'SolarService',
                'CartService',
                'CartAnalyticsService',
                'MobileMenuService',
                'SearchService',
                function (
                    $log,
                    $scope,
                    $state,
                    CookiesService,
                    HeaderService,
                    CategoriesService,
                    FiltersSortByService,
                    IndexService,
                    AccountAuthService,
                    SignupService,
                    UtilService,
                    CmsContentService,
                    NavLinksService,
                    SolarService,
                    CartService,
                    CartAnalyticsService,
                    MobileMenuService,
                    SearchService
                ) {
                    $scope.headerSvc = HeaderService;
                    $scope.mobileBackButton = HeaderService.mobileBackButton;
                    $scope.trackNavEngagement = HeaderService.trackNavEngagement;
                    $scope.siteTitle = UtilService.getSiteSetting('title');
                    $scope.mobileLogo = UtilService.getSiteSetting('mobile_logo');
                    $scope.compactLogo = UtilService.getSiteSetting('compact_logo');
                    $scope.isLoggedInResponse = AccountAuthService.isLoggedInResponse;
                    $scope.searchTerm = null;
                    $scope.searchResults = [];
                    $scope.isAutocompleteOpen = SearchService.isAutocompleteOpen;
                    $scope.toggleAutocomplete = SearchService.toggleAutocomplete;
                    HeaderService.getHeaderData().then(function(data) {
                        $scope.header_info = data;
                    });
                    $scope.utilityRateSelectorEnabled = UtilService.isFeatureEnabled('utility_rate_selector');
                    $scope.utilityStateRateSelectorEnabled = UtilService.isFeatureEnabled('utility_state_rate_selector');
                    $scope.rebateFastTrackEnabled = UtilService.isFeatureEnabled('rebate_fast_track')
                        || UtilService.getSiteSetting('rebate_fast_track_url')
                        || UtilService.isFeatureEnabled('fast_track_with_rrapi');
                    CmsContentService.retrieveCMSValue($scope, 'searchBoxText', 'base:header:search_box_text');
                    CmsContentService.retrieveCMSValue($scope, 'pleaseEnterSearchText', 'base:please_enter_search_text');
                    CmsContentService.retrieveCMSValue($scope, 'favoriteProductsText', 'base:header:favorite_products');

                    var isCheckoutEnabled = UtilService.isFeatureEnabled('checkout_enabled');
                    $scope.isCartEnabled = isCheckoutEnabled;
                    $scope.openCart = function () {
                        CartService.openCart();
                        CartAnalyticsService.reportEvent('Cart Viewed', {
                            location: 'header',
                        });
                    };
                    $scope.cartDetails = CartService.cartDetails;

                    $scope.closeSolarOverlay = function() {
                        if (UtilService.isFeatureEnabled('pick_my_solar')) {
                            SolarService.closeSolarWidget();
                        }
                    };

                    $scope.displayWelcomeModal = function () {

                        IndexService.openModal('#modal-welcome');
                    };

                    $scope.showPleaseEnterTextPopover = false;

                    $scope.isIndexPage = true;
                    $scope.$on('$stateChangeSuccess', () => {
                        $scope.isIndexPage = $state.current.name === 'index';
                    });

                    $scope.openSignInModal = function (button_name) {
                        IndexService.setSignupModalHeaders(button_name);
                        IndexService.openModal('#modal-enter-email');
                    };

                    $scope.calloutParentClass = "";

                    var processActiveSortBy = function () {
                        $scope.activeSortBy = FiltersSortByService.getActiveSortByOption();
                    };

                    CategoriesService.getCategories().then(function() {
                        $scope.categories = CategoriesService.getOrderedCategories();
                        processActiveSortBy();
                    });

                    NavLinksService.getShowDropdownLinks().then(function (links) {
                        $scope.showHeaderDropdown = links;
                    });

                    /**
                     * Header link routing based on user state
                     */
                    $scope.goToSavedProducts = function () {

                        if (!$scope.isLoggedInResponse.is_authenticated) {
                            $scope.trackNavEngagement('saved products', '');
                            // Show the sign in modal to unauthenticated users
                            IndexService.setSignupModalHeaders('save_product');
                            $scope.openSignInModal();
                        } else {
                            // Take authenticated users to the page
                            $scope.trackNavEngagement('saved products', 'fav-products');
                            $state.go('fav-products', {sortBy: $scope.activeSortBy});
                        }
                    };

                    $scope.goToSavedSearches = function () {

                        if (!$scope.isLoggedInResponse.is_authenticated) {
                            $scope.trackNavEngagement('saved products', '');
                            // Show the sign in modal to unauthenticated users
                            IndexService.setSignupModalHeaders('saved_searches');
                            $scope.openSignInModal();
                        } else {
                            // Take authenticated users to the page
                            $scope.trackNavEngagement('saved searches', 'my-searches');
                            $state.go('my-searches');
                        }
                    };

                    /**
                     * Goes to account page
                     */
                    $scope.goToAccount = function () {
                        $scope.trackNavEngagement('account', 'account');
                        $state.go('account');
                     };

                    /**
                     * Opens up the benefits modal if it's enabled and if it hasn't been see on first visit.
                     */
                    if (UtilService.getSiteSetting('first_visit_modals_to_display', []).indexOf('benefits_modal') !== -1) {
                        var has_seen_benefits_modal_cookie = CookiesService.get('has_seen_benefits_modal');
                        if (!has_seen_benefits_modal_cookie) {
                            CookiesService.set('has_seen_benefits_modal', 'true');
                            $scope.displayWelcomeModal();
                        }
                    }

                    var updateUserStatus = function () {
                        $scope.isLoggedInResponse = AccountAuthService.isLoggedInResponse;
                    };

                    AccountAuthService.onEveryAuthChange('updateHeaderUserStatus', updateUserStatus);

                    /**
                     * Mobile navigation menu
                     */
                    $scope.openMobileNav = MobileMenuService.openMobileNav;

                    HeaderService.getWagtailIndexSettings().then(function(indexSettings) {
                        if (indexSettings !== false) {
                            $scope.smallIndexLogo = indexSettings.use_small_index_logo;
                        } else {
                            $log.warn("Index Settings could not be loaded from CMS");
                            $log.warn("smallIndexLogo set to false");
                            $scope.smallIndexLogo = false;
                        }
                    });

                    HeaderService.getWagtailThemeSettings().then(function(themeSettings) {
                        var _defaultHeight = 40;
                        if (themeSettings !== false) {
                            $scope.globalHeaderLogoHeight = themeSettings.global_header_logo_height || _defaultHeight;
                        } else {
                            $scope.globalHeaderLogoHeight = _defaultHeight;
                        }
                    });

                    CategoriesService.updateCategoriesIcons($scope.categories);
                }],
            template: require('@app/shared/enerveeHeader/enerveeHeaderView.html'),
        };
    });
})(angular);
